import React, { useState, useEffect,useRef } from "react";
import { Drawer, List, ListItem, Tooltip,Box } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import StyledListItemIcon from "./Listiconstyles";
import MenuItem from '@mui/material/MenuItem';
import themeCreator from "@Themes/themeCreator";
import {useSelector} from "react-redux";
import SideBarMenuItems from "./SideBarMenuItems";
import {MenuStyles, SideBarStyles} from "./SideBarStyles";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [prevSelectedIndex, setprevSelectedIndex] = useState(null);
  const [selectedChildIndex,setSelectedChildIndex] = useState(-1);
  const [open,setOpen] = useState(false)
  const anchorRef = useRef(null);  // For controlling the menubar
  const theme = themeCreator()
  const user = useSelector((state) => state.user);

  useEffect(() => {
    const currentPath = location.pathname;

    const currentIndex = menuItems.findIndex(item => { return item.path === currentPath || item.children?.filter(child => child.path === currentPath).length === 1});
    if (currentIndex !== -1) {
      setSelectedIndex(currentIndex);
    }
  }, [location.pathname]);

  const menuItems = SideBarMenuItems(user.roles);
  const handleListChildrenItemClick = (index, path) => {
    const curIndex = selectedIndex;
    setprevSelectedIndex(curIndex);
    navigate(path);
  };
  const handleListItemClick = (index, path) => {
    setSelectedIndex(index);
    navigate(path);
  };
  const handleMenuOpen = (index) => {
    setOpen(true);
    setprevSelectedIndex(selectedIndex)
     setSelectedIndex(index);
  };
  const handleMenuClose = (event) => {
    const prevIndex = prevSelectedIndex;
    const curIndex = selectedIndex
    setSelectedIndex(prevIndex);
    setprevSelectedIndex(curIndex);
    setOpen(false);

  };

  const menuItemsChildren = (
    Boolean(menuItems[selectedIndex].children)&&
  <MenuStyles
    classes={{
      paper: 'overriderMenuPaper',
      list: 'overrideMenuList'
    }}

    anchorEl={anchorRef.current}
    open={open}
    onClose={handleMenuClose}
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'left',
    }}
    MenuListProps={{
    }}

  >
    {menuItems[selectedIndex].children.map((child, childIndex) => (
      <MenuItem
        key={childIndex}
        onClick={() => {
          handleMenuClose();
          handleListChildrenItemClick(prevSelectedIndex, child.path);
          setSelectedChildIndex(-1);
           // Navigate to the selected child path
            // Close the menu after selection
        }}
        onMouseEnter={()=>{
          setSelectedChildIndex(childIndex)}
        }
        onMouseLeave={()=>{setSelectedChildIndex(-1)}}
      >
        <StyledListItemIcon selectedIndex={selectedChildIndex} index={childIndex}>
          {child.icon}
        </StyledListItemIcon>
        {child.text}
      </MenuItem>
    ))}
  </MenuStyles>)


  return (
    <SideBarStyles>
      <Drawer
        className="drawerStyles"
        variant="permanent"
        anchor="left"
        disableScrollLock
      >
        <List >
          {menuItems.map((item, index) => (
            <Box key={index}
            >
              <Tooltip title={item.text} className="sidebarItemTooltip" placement="right">
                <ListItem button ref = {item.children?anchorRef:""}
                          onClick={(event) => item.children ? handleMenuOpen(index) : handleListItemClick(index, item.path)}
                  >
                  <StyledListItemIcon selectedIndex={selectedIndex} index={index}>
                    {item.icon}
                  </StyledListItemIcon>
                </ListItem>
              </Tooltip>
            </Box>
          ))}
        </List>
      </Drawer>

      <>{menuItemsChildren}</>

    </SideBarStyles>
  );
};

export default Sidebar;
